import React from "react";
import ReactTable from "react-table";
import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import {Link} from "react-router-dom";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import {formatPaymentMethodSlugLabel} from "../../utils/paymentMethodLabel";

class LayawayPaymentRefunds extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Layaways_Payment_Refunds._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 5;
		this.limit = 5;
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const safeData = Array.isArray(data) ? data : [];
		const accountName = this.props.rootState?.account_name || "Account";
		const defaultSortId = this.model?.sort || "created";

		const columns = [
			{
				Header: "Payment",
				id: "payment",
				className: 'center-column',
				accessor: (r) => {
					if (r?.layaway_payments && typeof r.layaway_payments === "object") {
						const desc = r.layaway_payments.description || "";
						const amt = r.layaway_payments.amount != null ? `$${r.layaway_payments.amount}` : "";
						return [desc, amt].filter(Boolean).join(" · ") || `#${r.payment}`;
					}
					return r?.payment != null ? `#${r.payment}` : "";
				},
			},
			{
				Header: "Refund Amount",
				id: "amount",
				className: 'center-column',
				accessor: (r) => r?.amount ?? "",
			},
			{
				Header: "Restocking Fee",
				id: "restocking_fee",
				className: 'center-column',
				accessor: (r) => (r?.restocking_fee ? r.restocking_fee : "0.00"),
			},
			{
				Header: "Date",
				id: "created",
				className: 'center-column',
				accessor: (r) => {
					if (!r?.created) {
						return "";
					}
					const parsed = moment(r.created);
					return parsed.isValid() ? parsed.local().format("MM/DD/YYYY hh:mm A") : "";
				},
			},
			{
				Header: "User",
				id: "user",
				className: 'center-column',
				accessor: (r) =>
					r?.users != null
						? `${r.users.name_first || ""} ${r.users.name_last || ""}`.trim()
						: accountName,
				Cell: (cellProps) =>
					cellProps.original?.users != null ? (
						<Link to={"/users/" + cellProps.original.users.pkey}>{cellProps.value}</Link>
					) : (
						<Link to={"/settings"}>{accountName}</Link>
					),
			},
			{
				Header: "Method",
				id: "method",
				className: 'center-column',
				accessor: (r) => formatPaymentMethodSlugLabel(r?.method) || r?.method || "",
			},
			{
				Header: "Note",
				id: "note",
				className: 'center-column',
				accessor: (r) => r?.note || "",
			},
		];

		return (
			<>
				<div className="table-bar">
					<div className="d-flex">{this.renderHeaderRight("LayawayPaymentRefunds", columns)}</div>
				</div>
				<ReactTable
					columns={columns}
					manual
					data={safeData}
					pages={pages || 0}
					loading={loading}
					loadingText="Requesting Data"
					onFetchData={this.fetchData}
					defaultSorted={[
						{
							id: defaultSortId,
							desc: this.model?.order === "desc",
						},
					]}
					showPagination={true}
					showPaginationTop={false}
					showPaginationBottom={true}
					showPageSizeOptions={true}
					defaultPageSize={limit}
					pageSize={limit}
					className="-striped -highlight"
				/>
				{APPCONFIG.settings.isDev() ? null : (
					<div className={classNames("tabled", "loader", {active: loading})}>
						<ClipLoader color={"#4A4A4A"} loading={loading} />
					</div>
				)}
			</>
		);
	}
}

export default Framework.Components.withRootState(LayawayPaymentRefunds);
